import { Table } from "antd";
import { useLocation } from "react-router-dom";
import { paginationOptions } from "../../../utils/Constants";

const TableContent = ({
  showLoader,
  className,
  bordered,
  loading,
  columns,
  rowClassName,
  rowSelection,
  onClick,
  list,
  storeList,
  components,
  pagination,
  totalCount,
  handlePaginationChange,
}) => {
  const location = useLocation();

  return (
    <>
      <Table
        rowSelection={rowSelection}
        className={className}
        columns={columns}
        components={components}
        bordered={bordered}
        dataSource={storeList}
        rowClassName={rowClassName}
        loading={loading}
        pagination={
          location.pathname.replace("/", "") === "dashboard"
            ? false
            : totalCount <= process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE
            ? false
            : !pagination
            ? false
            : {
                current: pagination?.current || 1,
                pageSize:
                  pagination?.pageSize ||
                  process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE,
                total:
                  location.pathname.replace("/", "") === "expense-code"
                    ? totalCount
                    : totalCount,
                pageSizeOptions: paginationOptions(totalCount),
                showSizeChanger: true,
                onChange: (page, pageSize) => {
                  handlePaginationChange(page, pageSize);
                },
                onShowSizeChange: (page, pageSize) => {
                  handlePaginationChange(page, pageSize);
                },
              }
        }
      />
    </>
  );
};
/**/
export default TableContent;
